import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useIssueSelectionStore } from "@/store/zustand/issueSelectionStore";
import { ListTodo, X } from "lucide-react";
import React from "react";

interface Props {
  onClear?: () => void;
}

export const SelectedIssuesContext: React.FC<Props> = React.memo(
  ({ onClear }) => {
    const selectedIssueIds = useIssueSelectionStore(
      (state) => state.selectedIssueIds,
    );
    const clearSelection = useIssueSelectionStore(
      (state) => state.clearSelection,
    );

    if (selectedIssueIds.size === 0) return null;

    return (
      <Button
        variant="ghost"
        size="sm"
        className={cn(
          "h-4 text-primary-n-500 bg-[#6448EF]/20 p-2 py-3 flex gap-1 text-3xs font-medium mb-0.5 cursor-pointer w-fit",
          "hover:text-primary-n-500 hover:bg-[#6448EF]/20",
        )}
        onClick={onClear || clearSelection}
      >
        <ListTodo className="stroke-primary-n-500 h-2.5 w-2.5" />
        <span>
          {selectedIssueIds.size} issue{selectedIssueIds.size > 1 ? "s" : ""}{" "}
          selected
        </span>
        <X className="stroke-primary-n-500 h-2.5 w-2.5" />
      </Button>
    );
  },
);

SelectedIssuesContext.displayName = "SelectedIssuesContext";
